import React from 'react';
import AdminEmailsContainer from '../components/adminEmails.container';

/** `/admin/emails` — the global email log and the suppression list, in two tabs. */
const AdminEmailsPage: React.FC = () => <AdminEmailsContainer />;

export default AdminEmailsPage;
